var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.75,
    height: 28,
    role: "img",
    "aria-label": "WEBSITE",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WEBSITE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.75,
    height: 28,
    fill: "#000000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkFib3V0Lm1lPC90aXRsZT48cGF0aCBkPSJNMTEuNDI3IDE2LjYxNXYtNi4wNDJjMC0uOTk3LS40NDQtMS42NjktMS41NDEtMS42NjktLjkwNiAwLTEuNzU0LjYxNC0yLjE1OSAxLjIyOHY2LjQ4M0g1LjcwNHYtNi4wNDJjMC0uOTk3LS40MjMtMS42NjktMS41MjMtMS42NjktLjkwNSAwLTEuNzM0LjYzMy0yLjE1OCAxLjIyOHY2LjQ4M0gwVjcuMzUxaDIuMDIzdjEuMjQ3QzIuNDI4IDguMDQgMy42NDIgNy4xMiA1LjA2OCA3LjEyYzEuMzg2IDAgMi4yMzUuNjkgMi41NDMgMS42ODguNTItLjgyNSAxLjc1NC0xLjY4OCAzLjE2LTEuNjg4IDEuNjk3IDAgMi42OC45MiAyLjY4IDIuOHY2LjY5NGgtMi4wMjR6TTI0IDEyLjE2M2MwLTIuOTI1LTEuNzg4LTUuMDQyLTQuNjA0LTUuMDQyLTIuNzc3IDAtNC43NTkgMi4xNzQtNC43NTkgNC44NjkgMCAyLjk0NSAyLjA3OSA0Ljg4OCA0LjkxMyA0Ljg5IDEuNDc2IDAgMi44NTUtLjQ4MiAzLjgwNy0xLjM2OGwtLjkzMi0xLjMyOGMtLjY4LjY3My0xLjc0NyAxLjA0LTIuNjggMS4wNC0xLjc2OCAwLTIuODE1LTEuMTc0LTIuOTcxLTIuNTZIMjR2LS41em0tNy4yNDUtLjk0M2MuMDc3LTEuMTE2Ljg5My0yLjQ0NCAyLjYyMi0yLjQ0NCAxLjg0NSAwIDIuNjAyIDEuMzQ3IDIuNjYgMi40NDRoLTUuMjgyeiIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 618.75,
    y: 175,
    textLength: 597.5,
    fill: "#fff",
    fontWeight: "bold"
  }, "WEBSITE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteBadge);
export default __webpack_public_path__ + "static/media/website_badge.b52e431a1020a1e3bc767d9f6be7b325.svg";
export { ForwardRef as ReactComponent };